// sidebarTheme.ts
// Centralized theme configuration for sidebar components
import { CONFIG_COLOR_OBJ } from "./constants/api.config";


const rgba = (r, g, b, a) => {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};

// Default theme object - can be customized
// const themeObject = {
//     mainColor: {
//         r: 255,
//         g: 255,
//         b: 255
//     },
//     secondMainColor: {
//         r: 46,
//         g: 184,
//         b: 92
//     },
//     opacity: {
//         opaque: 1,
//         high: 0.9,
//         medium: 0.5,
//         low: 0.2,
//         faint: 0.06
//     }
// };

// const themeObject = {
//     mainColor: {
//         r: 255,
//         g: 255,
//         b: 255
//     },
//     secondMainColor: {
//         r: 91,
//         g: 76,
//         b: 226
//     },
//     opacity: {
//         opaque: 1,
//         high: 0.9,
//         medium: 0.5,
//         low: 0.2,
//         faint: 0.06
//     }
// };



const opacity = {
    opaque: 1,
    high: 0.9,
    medium: 0.5,
    low: 0.2,
    faint: 0.06
}
const themeObject = CONFIG_COLOR_OBJ ? { ...CONFIG_COLOR_OBJ, opacity: opacity } : {
    mainColor: {
        r: 25,
        g: 118,
        b: 210
    },
    secondMainColor: {
        r: 255,
        g: 255,
        b: 255
    },
    opacity: opacity
};

export const isBackGroundWhite = themeObject.mainColor.r === 255 && themeObject.mainColor.g === 255 && themeObject.mainColor.b === 255


const sidebarTheme = {
    colors: {
        primary: {
            main: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.opaque),
            high: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.high),
            dark: rgba(themeObject.mainColor.r - 15, themeObject.mainColor.g - 15, themeObject.mainColor.b - 15, themeObject.opacity.opaque),
            light: rgba(themeObject.mainColor.r + 15, themeObject.mainColor.g + 15, themeObject.mainColor.b + 15, themeObject.opacity.opaque),
            hover: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.low),
            active: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.medium),
            text: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.opaque),
            textMuted: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.medium)
        },
        background: {
            main: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.opaque),
            collapsed: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.opaque),
            expanded: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.high),
            expandedHover: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.medium),
            hover: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.low),
            navGroupHover: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.opaque),
            active: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.low)
        },
        text: {
            primary: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.opaque),
            secondary: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.high),
            muted: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.medium),
            low: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.faint),
            low: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.low)
        },
        icon: {
            default: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.opaque),
            active: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.opaque),
            hover: rgba(themeObject.mainColor.r, themeObject.mainColor.g, themeObject.mainColor.b, themeObject.opacity.opaque)
        },
        divider: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.opaque),
        scrollbar: {
            thumb: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.low),
            thumbHover: rgba(themeObject.secondMainColor.r, themeObject.secondMainColor.g, themeObject.secondMainColor.b, themeObject.opacity.medium)
        }
    },
    opacity: themeObject.opacity,
    transitions: {
        default: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
    }
};

export { themeObject };
export default sidebarTheme;